import React from 'react';

import { Box, makeStyles } from '@material-ui/core';
import { CalendarMonthOutlined } from '@mui/icons-material';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  date: {
    fontSize: '14px',
    lineHeight: '17px',
  },
  dateButton: {
    color: '#999 !important',
    height: '30px',
    width: '100%',
  },
  dateContainer: {
    '& input[type="date"]': {
      boxSizing: 'border-box',
      cursor: 'pointer',
      height: '30px !important',
      left: 0,
      opacity: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      height: '100%',
      left: 0,
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
    },
    '&:hover': {
      '& .date': {
        color: '#444',
      },
      '& path': {
        color: '#444',
      },
      borderColor: `${theme.palette.primary.main} !important`,
      cursor: 'pointer',
    },
    border: '1px solid #C8C8C8',
    borderRadius: '8px',
    display: 'inline-block',
    height: '30px !important',
    marginTop: '2px',
    padding: '0 12px',
    position: 'relative',
    width: 146,
  },
  dateIcon: {
    color: '#999999',
  },
}));

export default function DatePicker({ displayDate, onChange, defaultText = 'Date' }) {
  const classes = useStyles();

  const handleDateChange = (event) => {
    const newValue = event.target.value;

    if (!newValue) {
      onChange(null);
      return;
    }

    const formattedDate = moment(newValue).format('MM-DD-YYYY');
    onChange(formattedDate);
  };

  const inputValue = displayDate ? moment(displayDate, 'MM-DD-YYYY').format('YYYY-MM-DD') : '';

  return (
    <Box className={classes.dateContainer}>
      <Box display="flex" gridGap={8} alignItems="center" borderRadius={8} className={classes.dateButton}>
        <CalendarMonthOutlined className={classes.dateIcon} />
        <div className="date">{displayDate || defaultText}</div>
      </Box>
      <input type="date" value={inputValue} onChange={handleDateChange} />
    </Box>
  );
}
